import * as WebBrowser from 'expo-web-browser';
import * as React from 'react';
import { Alert, Platform, StyleSheet, ToastAndroid } from 'react-native';
import {
  Box,
  Heading,
  Center,
  Stack,
  Spacer,
  Button,
  ChevronRightIcon,
  Radio,
  Text,
  FormControl,
  Input,
  HStack,
  Switch
} from 'native-base';
import { FormContext } from '../../stores/Store.tsx';
import PreLoader from '../../components/PreLoader';
import { SafeAreaView } from 'react-native-safe-area-context';

var numeral = require('numeral');


export default function DeclarationScreen(props) {
  const { navigation } = props;
  let [form, setForm] = React.useContext(FormContext);
  const [isDeclarationValid, setIsDeclarationValir] = React.useState(false)
  const [declarationObservations, setObservations] = React.useState('');
  const [working, setWorking] = React.useState(false);

  const handleChange = () => {
    setForm((prev) => {
      return {
        ...prev, ...{ isDeclarationValid, declarationObservations }
      }
    });
  }

  const continueForm = () => {
    handleChange()
    navigation.navigate('VehicleKindScreen')
  }


  if (working) {
    return <PreLoader />;
  }

  return (
    <Center flex={1}>
      <SafeAreaView style={{ flex: 1, padding: 10 }}>
        <Box
          rounded="lg"
          overflow="hidden"
          width={{
            base: 'xs',
            sm: 'xl',
            md: 768,
            lg: 992,
            xl: 1280,
          }}
          height="full"
          shadow={1}
          _light={{ backgroundColor: 'gray.50' }}
          _dark={{ backgroundColor: 'gray.700' }}
        >
          <Stack p="4" space={3}>
            <Stack space={2}>
              <Heading size="md" ml="-1">
                {`Inspector: ${form.inspector}`}
              </Heading>
            </Stack>
            <Text fontWeight="400">
              {`Cumple el Conductor con lo declarado en la Notificación`}
            </Text>
            <HStack mt="5%" width="xs" alignItems="center" space={4}>
              <Text fontSize="md">¿Cumple con lo declarado?</Text>
              <Switch size="md" isChecked={isDeclarationValid} onToggle={(val) => setIsDeclarationValir(val)} />
            </HStack>
            <FormControl>
              <Stack>
                <FormControl.Label>Observaciones</FormControl.Label>
                <Input onChangeText={(text) => setObservations(text)} placeholder="Observaciones" />
              </Stack>
            </FormControl>
          </Stack>
          <Spacer />
          <Box>
            <HStack>
              <Spacer />
              <Button
                disabled={!isDeclarationValid}
                rightIcon={<ChevronRightIcon color="white" />}
                colorScheme={isDeclarationValid ? "info" : "gray"}
                size="md"
                onPress={() => continueForm()}
              >
                Continuar
              </Button>
            </HStack>

          </Box>
        </Box>
      </SafeAreaView>
    </Center>
  );
}
